<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="5"></HeaderRegion>

    <div id="mainPage">
      <div class="user">
        <!-- 导入用户导航栏 -->
        <div class="user-nav">
          <UserNavigationBar ref="UserFrom"></UserNavigationBar>
        </div>

        <!-- 导入个人信息 -->
        <div class="user-region">
          <CoverWork ref="coverWorkFrom"></CoverWork>
        </div>
      </div>
    </div>

    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
  import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
  import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
  import UserNavigationBar from "../../components/userNavigationBar/userNavigationBar"; //导入用户导航栏
  import CoverWork from "../../components/coverWork/coverWork.vue"; //导入用户导航栏
  export default {
    name: "coverwork",
    components: {
      HeaderRegion,
      BottomRegion,
      UserNavigationBar,
      CoverWork,
    },
    created() {
      
    }
  }
</script>

<style scoped>
  .container {
    width: 100%;
  }

  .user {
    /* width: 62%; */
  /*  padding: 27px 367px;
    display: flex;
    align-items: flex-start; */

    width: 1186px;
    margin: 0 auto;
    padding: 27px 0;
    display: flex;
    align-items: flex-start;
  }

  .user-nav {
    display: inline-block;
    /* width: 21.5%; */
    margin: 0 3.5%  0 0;
  }

  .user-region {
    width: 900px;
    height: 650px;
    display: inline-block;
    overflow-y: auto;
    background-color: #FFFFFF;
    
  }
  .user-region::-webkit-scrollbar {display:none}
</style>



// WEBPACK FOOTER //
// src/pages/myCoverWork/myCoverWork.vue